import { render, staticRenderFns } from "./InfoBasic.vue?vue&type=template&id=71f95154&scoped=true&"
import script from "./InfoBasic.vue?vue&type=script&lang=js&"
export * from "./InfoBasic.vue?vue&type=script&lang=js&"
import style0 from "./InfoBasic.vue?vue&type=style&index=0&id=71f95154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f95154",
  null
  
)

export default component.exports